import { lazy } from "react";

export const PageViewOrganizationalStructure = lazy(() => import("./Container"));

